import React from "react";

const ThreeDNailArt = () => {
  return (
    <div className="blogWhat-content">
      <h5>6. 3D Nail Art: Bold & Beautiful</h5>
      <p>
        Nail art is stepping into the third dimension! From gemstones and pearls
        to raised floral details, 3D nail art is a favorite for those who love
        eye-catching, extravagant designs. You can choose minimalist bead
        accents or go all out with sculpted embellishments, making this trend
        completely customizable.
      </p>
    </div>
  );
};

export default ThreeDNailArt;
